import React, { useState, useEffect, useCallback } from 'react';
import './ChatBot.css'; // نستخدم نفس ملف CSS

// مكون روبوت المحادثة - إجابات مباشرة من قاعدة البيانات
const ChatBotGemini = () => {
  // حالة المحادثة
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([{
    text: 'مرحباً! أنا المساعد الآلي لمركز الأمل. كيف يمكنني مساعدتك؟\n\nيمكنك سؤالي عن خدماتنا أو اختيار أحد الأسئلة الشائعة أدناه.',
    sender: 'bot'
  }]);
  const [inputMessage, setInputMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showFAQ, setShowFAQ] = useState(true);
  
  // قاعدة بيانات الإجابات المباشرة
  const answersDatabase = {
    "ما هي الخدمات التي يقدمها مركز الأمل؟": "✔ الرعاية الصحية: فحوصات دورية، تطعيمات، ومتابعة طبية مستمرة.\n✔ الرعاية النفسية والاجتماعية: جلسات دعم نفسي، أنشطة تعزز الثقة والانتماء.\n✔ الإيواء والتغذية: مأوى آمن ووجبات غذائية متوازنة بإشراف مختصين.\n✔ التعليم الأولي: توفير فرص التعلم المبكر وبرامج ترفيهية لتنمية المهارات.\n✔ الدعم القانوني والإداري: تسهيل الإجراءات القانونية وضمان الحقوق.",
    "كيف يمكنني التواصل مع المركز؟": "📍 العنوان: الحي الإداري، تجزئة تامنيا، سطات\n📞 رقم الهاتف: +2126 06 71 3477\n📧 البريد الإلكتروني: anpemaroc@gmail.com",
    "ما هي الفئة العمرية للأطفال في المركز؟": "المركز يستقبل الأطفال من سن الرضاعة حتى 6 سنوات، ويوفر بيئة آمنة وملاذاً للأطفال المتخلى عنهم.",
    "ما هي مشكلة الأمهات العازبات في المغرب؟": "الأمهات العازبات في المغرب يواجهن تحديات اجتماعية ونفسية واقتصادية تشمل:\n- الخوف من العقاب القانوني\n- النبذ الأسري والضغوط المجتمعية\n- صعوبة تحقيق الاستقلالية المالية\n- التمييز الشديد في المدن والمناطق القروية",
    "كيف يمكنني المساهمة أو التطوع في المركز؟": "يمكنك التواصل مع المركز مباشرة:\n📞 رقم الهاتف: +2126 06 71 3477\n📧 البريد الإلكتروني: anpemaroc@gmail.com\nسيكون الفريق سعيداً بالتعاون معك.",
    "ما هي التحديات التي تواجه الأطفال المتخلى عنهم؟": "التحديات الرئيسية:\n- الحرمان من الهوية القانونية والوثائق الثبوتية\n- التشرد والاستغلال والعنف\n- المشاكل النفسية والاجتماعية بسبب غياب الأسرة الداعمة"
  };
  
  // تسجيل تحميل المكون
  useEffect(() => {
    console.log('✅ ChatBot Component Loaded - Direct Answers Mode');
  }, []);
  
  // قائمة الأسئلة الشائعة المستخرجة من المعلومات
  const frequentQuestions = [
    "ما هي الخدمات التي يقدمها مركز الأمل؟",
    "كيف يمكنني التواصل مع المركز؟",
    "ما هي الفئة العمرية للأطفال في المركز؟",
    "ما هي مشكلة الأمهات العازبات في المغرب؟",
    "كيف يمكنني المساهمة أو التطوع في المركز؟",
    "ما هي التحديات التي تواجه الأطفال المتخلى عنهم؟"
  ];
  
  // معالجة النقر على سؤال شائع
  const handleFAQClick = (question) => {
    // إضافة السؤال كرسالة من المستخدم
    setMessages(prev => [...prev, { text: question, sender: 'user' }]);
    setShowFAQ(false); // إخفاء الأسئلة الشائعة بعد اختيار سؤال
    
    // الحصول على الإجابة المباشرة
    handleGetDirectAnswer(question);
  };
  
  // دالة الحصول على إجابة مباشرة من قاعدة البيانات
  const handleGetDirectAnswer = (question) => {
    setIsLoading(true);
    
    // محاكاة تأخير صغير لتحسين تجربة المستخدم
    setTimeout(() => {
      let answer = answersDatabase[question];
      
      // إذا لم توجد إجابة مباشرة، عرض رسالة احترافية
      if (!answer) {
        answer = `شكراً لسؤالك! 😊\n\nهذا السؤال غير موجود حالياً في قاعدة بيانات المساعد الآلي.\n\nيمكنك التواصل مباشرة مع فريق مركز الأمل للحصول على إجابة دقيقة:\n\n📞 رقم الهاتف: +2126 06 71 3477\n📧 البريد الإلكتروني: anpemaroc@gmail.com\n\nسيكون الفريق سعيداً بمساعدتك! 💙`;
      }
      
      console.log('✅ إجابة مباشرة:', answer);
      setMessages(prev => [...prev, { text: answer, sender: 'bot' }]);
      setShowFAQ(true);
      setIsLoading(false);
    }, 500);
  };
  
  // معالجة إرسال الرسائل
  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!inputMessage.trim()) return;
    
    const userMessage = inputMessage.trim();
    setInputMessage('');
    setMessages(prev => [...prev, { text: userMessage, sender: 'user' }]);
    setShowFAQ(false); // إخفاء الأسئلة الشائعة عند إرسال رسالة
    
    // البحث عن إجابة مباشرة
    handleGetDirectAnswer(userMessage);
  };

  // فتح/إغلاق نافذة المحادثة
  const toggleChat = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  // التعامل مع ضغط مفتاح ESC لإغلاق الشات
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) {
        setIsOpen(false);
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  // تمرير الرسائل تلقائياً إلى آخر رسالة
  useEffect(() => {
    if (messages.length > 0) {
      const messagesContainer = document.querySelector('.messages-container');
      if (messagesContainer) {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      }
    }
  }, [messages]);

  return (
    <div className="chatbot-container">
      <button 
        className="chat-icon" 
        onClick={toggleChat}
        aria-label="فتح المحادثة"
        title="تحدث مع المساعد"
      >
        <i className="fas fa-comments"></i>
      </button>

      {isOpen && (
        <div className="chat-window modern-chat">
          <div className="chat-header">
            <div className="header-content">
              <i className="fas fa-child header-icon"></i>
              <h3>المساعد الآلي لمركز الأمل</h3>
            </div>
            <button 
              className="close-button" 
              onClick={toggleChat}
              aria-label="إغلاق المحادثة"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          <div className="messages-container">
            {messages.map((message, index) => (
              <div
                key={index}
                className={`message ${message.sender === 'user' ? 'user-message' : 'bot-message'}`}
                dir="rtl"
              >
                {message.sender === 'bot' && <div className="bot-avatar">
                  <i className="fas fa-robot"></i>
                </div>}
                <div className="message-content">
                  {message.text.split('\n').map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
                {message.sender === 'user' && <div className="user-avatar">
                  <i className="fas fa-user"></i>
                </div>}
              </div>
            ))}
            
            {showFAQ && !isLoading && messages.length > 0 && messages[messages.length-1].sender === 'bot' && (
              <div className="faq-container">
                <div className="faq-title">
                  <i className="fas fa-question-circle"></i>
                  <span>الأسئلة الشائعة</span>
                </div>
                <div className="faq-buttons">
                  {frequentQuestions.map((question, index) => (
                    <button 
                      key={index} 
                      className="faq-button"
                      onClick={() => handleFAQClick(question)}
                    >
                      {question}
                    </button>
                  ))}
                </div>
              </div>
            )}
            
            {isLoading && (
              <div className="bot-message loading">
                <div className="bot-avatar">
                  <i className="fas fa-robot"></i>
                </div>
                <div className="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            )}
          </div>

          <form className="input-container" onSubmit={handleSendMessage}>
            <button 
              type="submit"
              disabled={isLoading || !inputMessage.trim()}
              aria-label="إرسال الرسالة"
              className="send-button"
            >
              <i className="fas fa-paper-plane"></i>
            </button>
            <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              placeholder="اكتب رسالتك هنا..."
              dir="rtl"
              disabled={isLoading}
              aria-label="مربع إدخال الرسالة"
              className="chat-input"
            />
          </form>
        </div>
      )}
    </div>
  );
};

export default ChatBotGemini;
